import { APP_SETTING_ACTION as types, APP_STOCK_SETTING } from '../../constants/app';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { getSafe, getSafeStorage } from '@/helpers/global';
import { STORAGE_KEY } from '@/constants/storage.key';
const initialState = {
  mode: iTradeEnv?.reducers?.app?.mode || 'standalone',
  language: {},
  theme: 'light',
  isMobile: false,
  browser: '',
  geolocationCall: {},
  toast: null,
  isQuote: false,
  stockSetting: iTradeEnv?.actions?.app?.stock_theme ? APP_STOCK_SETTING.RED_RISE_GREEN_FALL :  APP_STOCK_SETTING.GREEN_RISE_RED_FALL,
  currentCtrl: {},
  isOpenMenuMobile: false,
  regions: [],
  appConfiguration: {},
  idTypeList:[],
  accessibility: getSafe(() => JSON.parse(getSafeStorage(STORAGE_KEY.ACCESSIBILITY)), { showFontSizeEdit: false, fontSizeMagnification : 1 }),
  needWithdrawal: false
}

export const appReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.DETECT_DEVICE:
      return Object.assign({}, state, {
        isMobile: action.isMobile,
        browser: action.browser || state.browser,
        geolocationCall: action.geolocationCall || state.geolocationCall
      });
    case types.GET_APP_SETTING:
      return Object.assign({}, state, {
        language: action.language || state.language,
        theme: action.theme || state.theme,
        regions: action.regions || state.regions,
        appConfiguration: action.appConfiguration || state.appConfiguration
      });
    case types.SWITCH_LANGUAGE:

      return Object.assign({}, state, {
        language: action.language || state.language
      });
    case types.SWITCH_MODE:
      return Object.assign({}, state, {
        mode: action.mode || action.mode
      })
    case types.SWITCH_THEME:
      return Object.assign({}, state, {
        theme: action.theme || state.theme,
        appConfiguration: action.appConfiguration || state.appConfiguration
      });
    case types.SHOW_TOAST:
      return Object.assign({}, state, {
        toast: action.toast
      });
    case types.TOGGLE_QUOTE:
      return Object.assign({}, state, {
        isQuote: action.isQuote
      });
    case types.SWITCH_STOCK_SETTING:
      return Object.assign({}, state, {
        stockSetting: action.stockSetting || state.stockSetting
      });
    case types.SWITCH_MENU_CONTROL:
      return Object.assign({}, state, {
        currentCtrl: action.menuCtrl || state.currentCtrl
      });
    case types.TOGGLE_MENU_MOBILE:
      return Object.assign({}, state, {
        isOpenMenuMobile: action.isOpenMenuMobile
      })
    case types.IDTYPE_LIST:
      return Object.assign({}, state, {
        idTypeList: action.idTypeList
      })
    case types.SET_ACCESSIBILITY:
      return Object.assign({}, state, {
        accessibility: { showFontSizeEdit: action.showFontSizeEdit, fontSizeMagnification: action.fontSizeMagnification }
      })
      case types.UPDATE_WITHDRAWAL:
        return Object.assign({}, state, {
          needWithdrawal: action.needWithdrawal
        })
    default:
      return state
  }
}
